module.exports = __webpack_public_path__ + "static/img/inbody2.4d71aac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/home/inbody2.png
// module id = 7xqe
// module chunks = 1